
const PrismJSON = {
  ok(value) {
    let type = typeof value;
    if ((value instanceof Array) || (type === 'number' || type === 'string' || type === 'boolean' || type === 'object')) {
      return true;
    }
    return false;
  },
  decode(string) {
    return $.parseJSON(string);
  },
  encode(value) {
    let i; let key; let str; let _len;
    const type = typeof value;

    if (value === null || type === 'undefined') return 'null';
    if (value instanceof Array) {
      str = '';
      i = 0;
      while (i < value.length) {
        if (PrismJSON.ok(value[i])) {
          if (i > 0) str += ', ';
          str += PrismJSON.encode(value[i]);
        }
        i += 1;
      }
      return `[${str}]`;
    } if (type === 'number') {
      return String(value);
    } if (type === 'string') {
      return `"${value.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r')}"`;
    } if (type === 'boolean') {
      return (value ? 'true' : 'false');
    } if (type === 'object') {
      str = '';
      const keys = ((function () {
        const _results = [];
        for (key in value) {
          if (value.hasOwnProperty(key) && PrismJSON.ok(value[key])) _results.push(key);
        }
        return _results;
      })()).sort();

      for (i = 0, _len = keys.length; i < _len; i++) {
        key = keys[i];
        if (i > 0) str += ', ';
        str += `${PrismJSON.encode(key)}: ${PrismJSON.encode(value[key])}`;
      }
      return `{${str}}`;
    }

    return 'null';
  },
};

export default PrismJSON;
